import React, { Component } from 'react'
import { Button, Icon, Select } from 'antd'
import className from 'classnames'

export default class extends Component {
  state = {
    active: false,
    disabled: false
  }

  handleClick = () => {
    this.setState(state => ({
      active: !state.active
    }))
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  setRef = (node) => {
    this.ref = node
  }

  handleClickOutside = (event) => {
    const { disabled } = this.state
    if (!disabled && this.ref && !this.ref.contains(event.target)) {
      this.setState({ active: false })
    }
  }

  handleClear = () => {
    const {
      setFilterMatchAllTags,
      setFilterMatchAnyTags,
      setFilterMatchNoneTags
    } = this.props

    setFilterMatchAllTags([])
    setFilterMatchAnyTags([])
    setFilterMatchNoneTags([])
  }

  handleFocus = () => {
    this.setState({
      disabled: true
    })
  }

  handleBlur = () => {
    this.setState({
      disabled: false
    })
  }

  render () {
    const { active } = this.state
    const {
      tags,
      filters: { matchAllTags, matchAnyTags, matchNoneTags },
      setFilterMatchAllTags,
      setFilterMatchAnyTags,
      setFilterMatchNoneTags
    } = this.props

    return (
      <div className={className('dropdown', { 'dropdown_active': active })} ref={this.setRef}>
        <div className='dropdown__head'>
          <Button onClick={this.handleClick}>Tags <Icon type='down' /></Button>
        </div>
        <div className='dropdown__content' style={{ width: '18rem' }}>
          <div className='dropdown__inner'>
            <div className='filter-tags'>
              <div className='filter-tags__field'>
                <div className='filter-tags__label'>Match ANY of these tags</div>
                <div className='filter-tags__control'>
                  <Select
                    style={{ width: '100%' }}
                    mode='multiple'
                    onChange={setFilterMatchAnyTags}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    value={matchAnyTags.map(tag => tag.toString())}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    dropdownMatchSelectWidth={false}
                  >
                    { tags.map(tag => <Select.Option key={tag.id.toString()}>{ tag.value }</Select.Option>) }
                  </Select>
                </div>
              </div>
              <div className='filter-tags__field'>
                <div className='filter-tags__label'>Match ALL of these tags</div>
                <div className='filter-tags__control'>
                  <Select
                    style={{ width: '100%' }}
                    mode='multiple'
                    onChange={setFilterMatchAllTags}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    value={matchAllTags.map(tag => tag.toString())}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    dropdownMatchSelectWidth={false}
                  >
                    { tags.map(tag => <Select.Option key={tag.id.toString()}>{ tag.value }</Select.Option>) }
                  </Select>
                </div>
              </div>
              <div className='filter-tags__field'>
                <div className='filter-tags__label'>Match NONE of these tags</div>
                <div className='filter-tags__control'>
                  <Select
                    style={{ width: '100%' }}
                    mode='multiple'
                    onChange={setFilterMatchNoneTags}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    value={matchNoneTags.map(tag => tag.toString())}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    dropdownMatchSelectWidth={false}
                  >
                    { tags.map(tag => <Select.Option key={tag.id.toString()}>{ tag.value }</Select.Option>) }
                  </Select>
                </div>
              </div>
              <div className='filter-tags__buttons'>
                <div className='filter-tags__button'>
                  <Button type='dashed' size='small' block onClick={this.handleClear}>Clear</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Parts/FilterTags/FilterTags.jsx